import service from '@/store/services/device-licence-status-service';

const state = {
    status: {},
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, status) => {
        state.status = status;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }
};

const actions = {
    add({ commit, dispatch }, params) {
        return service.add(params)
            .then((status) => { commit('SET_RESOURCE', status); });
    },
    assignLicence({ commit, dispatch }, params) {
        return service.assignLicence(params)
            .then((status) => { commit('SET_RESOURCE', status); });
    },
};

const getters = {
    status: state => state.status
};

const deviceLicenceStatus = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default deviceLicenceStatus;